import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuthenticatedUser } from "@/hooks/useAuthenticatedUser";
import { hasAnyRole } from "@/utils/accessControl";
import { Role } from "@/types/user";
import { SubNavigation } from "@/components/pages/reservations/components/SubNavigation";

interface ReservationNavigationProps {
  activeTab: "staff" | "teams" | "roles";
}

export const StaffNavigation: React.FC<ReservationNavigationProps> = ({
  activeTab,
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { userProfile } = useAuthenticatedUser();
  const canManageRoles = hasAnyRole(userProfile, [
    Role.TENANT_ADMIN,
    Role.HOTEL_ADMIN,
    Role.FRONT_DESK,
  ]);

  const navigationItems = [
    { label: t("staff.tabs.staff"), path: "/staff", id: "staff" },
    { label: t("staff.tabs.teams"), path: "/staff/teams", id: "teams" },
    ...(canManageRoles
      ? [{ label: t("staff.tabs.roles"), path: "/staff/roles", id: "roles" }]
      : []),
  ];

  const handleTabChange = (tabId: string) => {
    const item = navigationItems.find((item) => item.id === tabId);
    if (item) {
      navigate(item.path);
    }
  };

  return (
    <SubNavigation
      activeTab={activeTab}
      onTabChange={handleTabChange}
      tabs={navigationItems}
    />
  );
};
